import React from "react";
// used for making the prop types of this component
import PropTypes from "prop-types";
import { Redirect } from "react-router-dom";
// reactstrap components
import {
  Collapse,
  Navbar,
  NavbarToggler,
  Nav,
  NavItem,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap";
import { getCurrentUser } from '../../services/AuthService'
import { jobStatusAlert, storagejobStatusAlert } from 'settings/shared/commonMethod'
import { Scrollbars } from 'react-custom-scrollbars';
import Avatar from 'react-avatar';
import { SOCKET_API_BASE_URL, ACCESS_TOKEN, MODULETYPES, WEBSOCKET_RECONNECT_MILLISECONDS, WEBSOCKET_NO_OF_TRY } from '../../settings/shared/constants';
import SockJS from 'sockjs-client'
import Stomp from 'stompjs'
import { Progress } from 'react-sweet-progress';
import "react-sweet-progress/lib/style.css";
import NotificationAlert from "react-notification-alert";
import RunService from '../../services/api/Run';
import { ToastContainer } from 'react-toastify';
import { Toaster } from 'react-hot-toast';
import UserService from '../../services/api/User';

class AdminNavbar extends React.Component {
  state = {
    isOpen: false,
    dropdownOpen: false,
    color: "transparent",
  };
  constructor(props) {
    super(props);
    this.state = {
      profile: '',
      notifyCount: 0,
      notifytrayArray: [],
      percent: 0,
      newtenant: true,
      endfreetrail: false,
      showQuickTour: false,
      avatarcolor: [
        'violet', 'coral', '#851fc4', 'sandybrown', 'pink', 'green', '#4d95db', '#aba9ad', '#f44336', '#9c27b0',
        '#673ab7', '#00bcd4'
      ],
      hardRefresh: false,
      userConnectionCount: 0,
      accountConnectionCount: 0
    };
    this.sidebar = React.createRef();

  }
  sidebarToggle = React.createRef();

  toggle = () => {
    if (this.state.isOpen) {
      this.setState({
        color: "transparent"
      });
    } else {
      this.setState({
        color: "white"
      });
    }
    this.setState({
      isOpen: !this.state.isOpen
    });
  };
  dropdownToggle = e => {
    this.setState({
      dropdownOpen: !this.state.dropdownOpen
    });
  };
  openSidebar = () => {
    document.documentElement.classList.toggle("nav-open");
    this.sidebarToggle.current.classList.toggle("toggled");
  };
  // function that adds color white/transparent to the navbar on resize (this is for the collapse)
  updateColor = () => {
    if (window.innerWidth < 993 && this.state.isOpen) {
      this.setState({
        color: "white"
      });
    } else {
      this.setState({
        color: "transparent"
      });
    }
  };
  // Clear all session while click logout button
  logoutHandler = () => {
    localStorage.clear();
    sessionStorage.clear();
    this.props.history.push('/auth/login-page');
    window.location.reload();
  }
  ProfileHandler = () => {
    this.props.history.push('/admin/profile');
  }

  ChangePasswordHandler = () => {
    this.props.history.push('/admin/changepassword');
  }
  notify = place => {
    var options = {};
    options = {
      place: place,
      message: (
        <div>
          <div>
            You have reached the {this.state.trailhrs} hrs of free trial usage. Please contact <a href="#" style={{ color: 'blue' }}>info@decisionforce.io </a>to upgrade
          </div>
        </div>
      ),
      type: "danger",
      icon: "fas fa-exclamation-triangle",
      // autoDismiss: 7
    };
    this.refs.notificationAlert.notificationAlert(options);
  };

  updateFirstTimeLogin = () => {
    let updateData = {
      lastLogin: true,
      organisation: localStorage.getItem("accountId")
    }

    if (localStorage.getItem("lastLogin") === "false") {
      UserService.UpdateUser(updateData, localStorage.getItem("Uid"))
        .then((response) => {
        });
    }
  }

  componentDidMount() {
    if (!localStorage.getItem('UserProfile')) {
      getCurrentUser()
        .then(response => {
          localStorage.setItem("UserProfile", JSON.stringify(response));
          this.setState({
            isAuthenticated: true,
            profile: JSON.parse(localStorage.getItem('UserProfile'))
          });
          let myProfile = JSON.parse(localStorage.getItem('UserProfile'))
          localStorage.setItem("accountId", myProfile.accountId);
          localStorage.setItem("accountType", myProfile.accountType);
        }).catch(error => {
          this.setState({
            loading: false
          });
        });
    } else {
      let myProfile = JSON.parse(localStorage.getItem('UserProfile'))
      localStorage.setItem("accountId", myProfile.accountId);
      localStorage.setItem("accountType", myProfile.accountType);
      this.setState({ isAuthenticated: true, profile: myProfile })
    }

    Promise.all([this.establishWebsocketForAccount(), this.establishWebsocketForUser(), this.getNewTenant()]).then(values => {
    })

    if (this.state.endfreetrail === true) {
      this.notify("tc")
    }
    window.addEventListener("resize", this.updateColor.bind(this));
    var abackground = this.state.avatarcolor[Math.floor(Math.random() * this.state.avatarcolor.length)];
    this.state.selectedColor = abackground;
    if (localStorage.getItem(ACCESS_TOKEN) !== null) {
      this.getComputeHours();
    }

    setTimeout(() => {
      this.updateFirstTimeLogin();
    }, 2000)

    if(!navigator.onLine){
      this.offlineEventHandler();
    }
  }



  getNewTenant = () => {
    if (localStorage.getItem("accountType") === "NEW") {
      this.setState({ newTenantUser: true })
    }
    else {
      this.setState({ newTenantUser: false })
    }
  }

  doHardRefresh = () => {
    this.setState({
      hardRefresh: false
    }, () => {
      if (navigator.onLine) {
        Promise.all([this.establishWebsocketForAccount(), this.establishWebsocketForUser(), this.getNewTenant()]).then(values => {
          this.setState({
            userConnectionCount: 0,
            accountConnectionCount: 0
          })
        })
      } else {
        this.offlineEventHandler();
      }
    })
  }

  getComputeHours = () => {
    RunService.getRunComputeHours()
      .then((response) => {
        let consumedPercentage = response.consumedPercentage;
        consumedPercentage = consumedPercentage || 0
        if (response.consumedPercentage === NaN) {
          consumedPercentage = ''
        }
        this.setState({
          consumedPercentage: consumedPercentage,
          percent: consumedPercentage,
          trailhrs: Math.round((response.totalMinutes / 60 + Number.EPSILON) * 100) / 100
        });
        if (this.state.percent >= 80) {
          this.state.status = "error"
        }
        if (this.state.percent >= 1 && this.state.percent < 30) {
          this.state.status = "success"
        }
        if (this.state.percent >= 30 && this.state.percent < 50) {
          this.state.status = "default"
        }
        if (this.state.percent >= 50 && this.state.percent < 80) {
          this.state.status = "active"
        }
        if (consumedPercentage >= 100) {
          this.setState({
            endfreetrail: true,
            percent: 100
          });
          this.notify("tc")
        }
      });
  }

  componentDidUpdate(e) {
    if (
      window.innerWidth < 993 &&
      e.history.location.pathname !== e.location.pathname &&
      document.documentElement.className.indexOf("nav-open") !== -1
    ) {
      document.documentElement.classList.toggle("nav-open");
      this.sidebarToggle.current.classList.toggle("toggled");
    }
  }
  // Reset Notification count
  notificationResetCount(item) {
    if (this.state.notifyCount !== 0) {
      this.setState((prevState) => ({
        notifyCount: prevState.notifyCount - 1,
      }))
    }
    if (this.state.notifyCount === 0) {
      this.setState({
        notifyCount: 0,
        notifytrayArray: []
      })
    }
    if (this.state.notifytrayArray.length === 0) {
      this.setState({
        notifyCount: 0,
        notifytrayArray: []
      })
    }
    if (item.hasOwnProperty('chatMasterId')) {
      let history = "";
      item.chatType === "RUN_CHAT_TYPE" ? localStorage.setItem("ctype", "Runs") : localStorage.setItem("ctype", "Project");
      let currentUrl = window.location.href;
      let reg = currentUrl.split("/");
      reg[3] === "viewProject" ? history = reg[3] + "/" + reg[4] : history = reg[3];
      localStorage.setItem("Pagehistory", history);
      this.props.history.push("/job/" + item.chatIdentifier + "?__o=" + "/" + history);

    }
  }

  eventHandlerUser = (noteData) => {
    if (noteData.notificationType === MODULETYPES.NOTIFICATION) {
      if (noteData.moduleType !== MODULETYPES.CHAT) {
        if (noteData.moduleType === MODULETYPES.STORAGE) {
          this.workerEventHandler(noteData)
        } else {
          this.setState((prevState) => ({
            notifyCount: prevState.notifyCount + 1,
            notifytrayArray: [...this.state.notifytrayArray, noteData.message]
          }))
        }
      } else {
        var finalData = JSON.parse(noteData.message);
        this.setState((prevState) => ({
          notifyCount: prevState.notifyCount + 1,
          notifytrayArray: [...this.state.notifytrayArray, finalData]
        }))
      }
    }
  }

  workerEventHandler = (param) => {
    switch (true) {
      case param.moduleType === MODULETYPES.CONSUMED_HOURS:
        return this.getComputeHours();
      case param.moduleType === MODULETYPES.CLUSTER:
        return this.clusterUpdateHandler(param);
      case param.notificationType === MODULETYPES.REFRESH && param.moduleType === MODULETYPES.RUN:
        return this.runUpdateHandler(param);
      case param.moduleType === MODULETYPES.STORAGE:
        return this.storageUpdateHandler(param)
      default:
        break;
    }
  }

  offlineEventHandler = () => {
    this.props.history.push('/auth/offline');
  }

  // For Storage websocket Update
  storageUpdateHandler = (param) => {
    let path = window.location.href;
    if (path.includes("storage")) {
      const eventStorage = new CustomEvent('ws-message-storage', {
        detail: {
          data: param
        }
      });
      window.dispatchEvent(eventStorage);
    } else {
      storagejobStatusAlert(param);
    }
  }

  // For runs websocket
  runUpdateHandler = (param) => {
    let routePath = window.location.href;
    if (routePath.includes("viewProject")) {
      const eventviewProject = new CustomEvent('ws-message-viewProject', {
        detail: {
          data: param
        }
      });
      window.dispatchEvent(eventviewProject);
    }
    else if (routePath.includes("runs")) {
      const eventRun = new CustomEvent('ws-message-run', {
        detail: {
          data: param
        }
      });
      window.dispatchEvent(eventRun);
    } else {
      jobStatusAlert(param.runId, param.runStatus, param.createdBy);
    }
  }
  // For Cluster websocket Update
  clusterUpdateHandler = (param) => {
    let path = window.location.href;
    if (path.includes("cluster/")) {
      const eventCluster = new CustomEvent('ws-message-cluster', {
        detail: {
          data: param
        }
      });
      window.dispatchEvent(eventCluster);
    }
  }
  // For Storage View websocket Update
  storageViewUpdateHandler = (param) => {
    let path = window.location.href;
    if (path.includes("StorageView")) {
      const eventStorage = new CustomEvent('ws-message-storage', {
        detail: {
          data: param
        }
      });
      window.dispatchEvent(eventStorage);
    }
  }
  toggleQuickTour = () => {
    if (this.state.showQuickTour) {
      this.setState({ showQuickTour: false, })
    } else {
      this.setState({
        showQuickTour: true,
      })
    }
  }


  // Web socket connection for user and account
  establishWebsocketForAccount = () => {
    var _this = this;
    var socket = new SockJS(SOCKET_API_BASE_URL);
    socket.onopen = _this.onOpenAccountEvent;
    socket.onclose = _this.onCloseAccountEvent;
    socket.onerror = _this.onErrorAccountEvent;
    var stompClient = Stomp.over(socket);
    stompClient.debug = null //Disable Ping pong console logs
    stompClient.connect('guest', 'guest', function (frame) {
      stompClient.subscribe('/topic/message' + localStorage.getItem("accountId"), function (notification) {
        let noteData = JSON.parse(notification.body);
        _this.workerEventHandler(noteData);
      })
    }, function (err) {
      _this.reconnectWebsocketAccount();
    });
  }

  onOpenAccountEvent = () =>{
    this.setState({ accountConnectionCount: 0 })
  }

  onCloseAccountEvent = () =>{
    this.reconnectWebsocketAccount();
  }

  onErrorAccountEvent = () =>{
    this.reconnectWebsocketAccount();
  }

  establishWebsocketForUser = () => {
    var _this = this;
    var userSocket = new SockJS(SOCKET_API_BASE_URL);
    userSocket.onopen = _this.onOpenUserEvent;
    userSocket.onclose = _this.onCloseUserEvent;
    userSocket.onerror = _this.onErrorUserEvent;
    userSocket.onmessage = _this.onmessageEvent;
    var userStompClient = Stomp.over(userSocket);
    userStompClient.debug = null //Disable Ping pong console logs
    userStompClient.connect('guest', 'guest', function (frame) {
      userStompClient.subscribe('/topic/message' + localStorage.getItem("Uid"), function (notification) {
        let noteData = JSON.parse(notification.body);
        _this.eventHandlerUser(noteData);
      })
    }, function (err) {
      _this.reconnectWebsocketUser();
    });

  }

  onOpenUserEvent = () =>{
    this.setState({ userConnectionCount: 0 })
  }

  onCloseUserEvent = () =>{
    this.reconnectWebsocketUser();
  }

  onErrorUserEvent = () =>{
    this.reconnectWebsocketUser();
  }


  reconnectWebsocketUser = () => {
    this.setState((prevState, props) => ({
      userConnectionCount : prevState.userConnectionCount + 1
    }))

    if(this.state.userConnectionCount < WEBSOCKET_NO_OF_TRY){
      setTimeout(() => {
        this.establishWebsocketForUser();
      }, WEBSOCKET_RECONNECT_MILLISECONDS)
    }else{
      this.setState({
        hardRefresh: true
      })
    }

  }

  reconnectWebsocketAccount = () => {
    this.setState((prevState, props) => ({
      accountConnectionCount : prevState.accountConnectionCount + 1
    }))

    if(this.state.accountConnectionCount < WEBSOCKET_NO_OF_TRY){
      setTimeout(() => {
        this.establishWebsocketForAccount();
      }, WEBSOCKET_RECONNECT_MILLISECONDS)
    }else{
      this.setState({
        hardRefresh: true
      })
    }
  }




  render() {
    const token = localStorage.getItem(ACCESS_TOKEN);
    if (token === null) {
      return <Redirect to={{
        pathname: "/auth/login-page",
        state: { from: this.props.location }
      }} />;
    }
    return (
      // add or remove classes depending if we are on full-screen-maps page or not
      <div>
        <Navbar
          color={
            window.location.href.indexOf("full-screen-maps") !== -1
              ? "white"
              : this.state.color
          }
          expand="lg"
          className={
            window.location.href.indexOf("full-screen-maps") !== -1
              ? "navbar-absolute "
              : "navbar-absolute " +
              (this.state.color === "transparent" ? "navbar-transparent " : "")
          }
        >
          <Container fluid>
            <div className="navbar-wrapper">
              <div className="navbar-toggle">
                <button
                  type="button"
                  ref={this.sidebarToggle}
                  className="navbar-toggler"
                  onClick={() => this.openSidebar()}
                >
                  <span className="navbar-toggler-bar bar1" />
                  <span className="navbar-toggler-bar bar2" />
                  <span className="navbar-toggler-bar bar3" />
                </button>
              </div>
            </div>
            <Row>

              <Card className=" shadow">
                <Col xs={12} md={10}>

                  <ToastContainer
                    position="top-center"
                    autoClose={1555}
                    hideProgressBar={true}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable={false}
                    pauseOnHover
                  />
                  <Toaster
                    position="bottom-right"
                    reverseOrder={true}
                    toastOptions={{
                      duration: 6000,
                      className: 'toastDiv'
                    }}
                  />
                </Col>
              </Card>
            </Row>
            <NavbarToggler onClick={this.toggle}>
              <span className="navbar-toggler-bar navbar-kebab" />
              <span className="navbar-toggler-bar navbar-kebab" />
              <span className="navbar-toggler-bar navbar-kebab" />
            </NavbarToggler>
            {this.state.newTenantUser === true &&
              <div>
                {this.state.newtenant === true &&
                  <Nav className="justify-content-end" >
                    <Row>
                      <Col lg="4"><code className="freecredits"><b>Free Credits</b></code></Col>
                      <Col lg="8"><Progress percent={this.state.percent} status={this.state.status}
                        theme={
                          {
                            error: {
                              symbol: this.state.percent + '%',
                              trailColor: '#efefef',
                              color: 'red'
                            },
                            default: {
                              symbol: this.state.percent + '%',
                              trailColor: '#efefef',
                              color: 'blue'
                            },
                            active: {
                              symbol: this.state.percent + '%',
                              trailColor: '#efefef',
                              color: 'orange'
                            },
                            success: {
                              symbol: this.state.percent + '%',
                              trailColor: '#efefef',
                              color: 'green'
                            }
                          }
                        }
                        className="progresswidth" />

                      </Col>
                    </Row>
                  </Nav>
                }
              </div>
            }

            <Collapse
              isOpen={this.state.isOpen}
              navbar
              className="justify-content-end">
              <Nav navbar>
                <NavItem>
                  {localStorage.getItem("accountType") === "NEW" &&
                    <div>
                      <span className="QuickTour" onClick={this.toggleQuickTour}><b><i className="fab fa-youtube red"></i>&nbsp;Quick Tour</b></span>
                    </div>
                  }</NavItem>&nbsp;&nbsp;&nbsp;&nbsp;

                {this.state.hardRefresh && <NavItem>
                  <span className="font-weight-bold font12 back-refresh" title="Refresh to see latest changes" onClick={e => this.doHardRefresh()}>Refresh</span>
                </NavItem>}&nbsp;&nbsp;&nbsp;&nbsp;

                <NavItem>
                  <UncontrolledDropdown>
                    {this.state.notifyCount !== 0 && <span className="button__badge">{this.state.notifyCount}</span>}
                    <DropdownToggle
                      tag="span"
                      onClick={e => e.preventDefault()}
                      style={{ color: '#007bff', cursor: 'pointer' }}>
                      <i className="fas fa-bell bellColor"></i>
                    </DropdownToggle>
                    {this.state.notifyCount !== 0 && <DropdownMenu
                      right
                      className="dropdown-menu-arrow" style={{ marginRight: 24 }}>
                      <Scrollbars autoHeight
                        autoHeightMin={0}
                        autoHeightMax={220}
                        thumbMinSize={30}>
                        {this.state.notifytrayArray.reverse().map((item, index) => (<DropdownItem
                          href="" style={{ cursor: "pointer" }} onClick={e => this.notificationResetCount(item)}>
                          <span>
                            {item.message}
                          </span>
                        </DropdownItem>
                        ))}
                      </Scrollbars>
                    </DropdownMenu>}
                    {this.state.notifyCount === 0 && <DropdownMenu
                      right
                      className="dropdown-menu-arrow" style={{ marginRight: 24 }}>
                      <DropdownItem
                        href="" style={{ cursor: "pointer" }}>
                        <span>
                          No Notifications
                        </span>
                      </DropdownItem>
                    </DropdownMenu>}
                  </UncontrolledDropdown>
                </NavItem>
                <NavItem>
                  <div className="avatar avatar-sm rounded-circle">
                    {this.state.profile.photoURL === null ? (
                      <Avatar round={true} color={this.state.selectedColor} name={this.state.profile.firstName + " " + this.state.profile.lastName} size="35" />

                    ) : <img src={this.state.profile.photoURL} alt={this.state.profile.firstName} style={{ borderRadius: '50px' }}
                    />}
                  </div>
                </NavItem>
                <Dropdown
                  nav
                  isOpen={this.state.dropdownOpen}
                  toggle={e => this.dropdownToggle(e)}
                >
                  <DropdownToggle caret nav>
                    <p>
                      <span className="d-lg-none d-md-block">{this.state.profile.firstName}</span>
                    </p>
                  </DropdownToggle>
                  <DropdownMenu right>
                    <DropdownItem tag="a" onClick={e => this.ProfileHandler()}>Profile</DropdownItem>
                    <DropdownItem tag="a" onClick={e => this.ChangePasswordHandler()}>Change Password</DropdownItem>
                    {localStorage.getItem("role") !== "PLATFORM_ADMIN" &&
                      <DropdownItem tag="a" onClick={e => this.toggleQuickTour()}>Quick Tour</DropdownItem>}
                    <DropdownItem tag="a" onClick={e => this.logoutHandler()}>Logout</DropdownItem>
                  </DropdownMenu>
                </Dropdown>

              </Nav>
            </Collapse>
          </Container>
        </Navbar>
        <Row>
          <Col lg="8">
            <NotificationAlert ref="notificationAlert" />
          </Col>
        </Row>
        <Modal
          id="quicktour"
          centered
          className="upload-modal"
          isOpen={this.state.showQuickTour}
          toggle={this.toggleQuickTour}
          backdrop="static"
          returnFocusAfterClose={false}
        >
          <ModalHeader toggle={this.toggleQuickTour}>Quick Tour on DecisionFacts</ModalHeader>
          <ModalBody>
            <hr className="hrStyle" />
            <CardBody>
              <iframe width="560" height="415"
                src="https://www.youtube.com/embed/TxsC1bnxht4?&autoplay=1&rel=0"
                title="Quick Tour on DecisionFacts" frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen>
              </iframe>
            </CardBody>
          </ModalBody>
        </Modal>
      </div>

    );
  }
}

AdminNavbar.defaultProps = {
  brandText: "Default Brand Text"
};

AdminNavbar.propTypes = {
  // string for the page name
  brandText: PropTypes.string
};

export default AdminNavbar;
